import type { ReactNode } from 'react';
import { embeddedViewRequested } from '../lib/helpers';

type Props = {
  alwaysOpenInNewTab?: boolean;
  children: ReactNode;
  className?: string;
  color?: string;
  'data-ref'?: string;
  href: string;
  title?: string;
};

const ExternalLink = ({ alwaysOpenInNewTab, children, className, color, 'data-ref': dataRef, href, title }: Props) => {
  const aProps = alwaysOpenInNewTab || embeddedViewRequested() ? { target: '_blank', rel: 'noopener noreferrer' } : {};

  return (
    <a
      style={{ textDecoration: 'underline', color: color || 'var(--color-blue-darker)' }}
      className={className}
      data-ref={dataRef}
      href={href}
      title={title}
      {...aProps}
    >
      {children}
    </a>
  );
};

export default ExternalLink;
